var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"chart-type__button",class:{ 'active': _vm.active },on:{"click":_vm.displayChart}},[_c('v-icon',{attrs:{"name":("chart-" + (_vm.chart.icon))}}),_vm._v("\n  "+_vm._s(_vm.chart.title)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }